import getReachedLiabilityForSku from './getReachedLiabilityForSku';

export default (orderFromEstimation: number, estimationValue: number): string => {
    let liabilityString = 'n/a';
    if (estimationValue > 0) {
        const reachedLiability = Math.floor(getReachedLiabilityForSku(orderFromEstimation, estimationValue));
        liabilityString = reachedLiability.toFixed(0) + '%';
    }
    return liabilityString;
};



// WEBPACK FOOTER //
// ./src/domain/orders/getLiability.ts